import type { FC, ReactNode } from "react";
import { EditableMetricCard, METRIC_CARD_HOVER_CLASS } from "../../../patterns/metric-card";
import { YesNo } from "../../../patterns/radio-select";
import { YesNoDisplay } from "../../../ui/YesNoDisplay";
import { HISTORY_CARD_LABEL_CLASS } from "./cardStyles";
import {
	type HistoryFieldSubmitCallbacks,
	useEditableHistoryField,
} from "./useEditableHistoryField";

export type HistoryYesNoCardProps = {
	testId: string;
	label: string;
	value: boolean | null;
	submit: (draft: boolean | null, callbacks: HistoryFieldSubmitCallbacks) => void;
	/** Optional long-form question rendered beneath the value. */
	caption?: ReactNode;
	readOnly?: boolean;
	errorHeading?: string;
};

export const HistoryYesNoCard: FC<HistoryYesNoCardProps> = ({
	testId,
	label,
	value,
	submit,
	caption,
	readOnly,
	errorHeading,
}) => {
	const { controller, draft, changeValue } = useEditableHistoryField<boolean | null>({
		value,
		submit,
	});

	return (
		<EditableMetricCard
			testId={testId}
			label={label}
			labelClassName={HISTORY_CARD_LABEL_CLASS}
			className={METRIC_CARD_HOVER_CLASS}
			readOnly={readOnly}
			errorHeading={errorHeading}
			controller={controller}
		>
			<EditableMetricCard.ValueRow data-testid={`${testId}-display`}>
				{controller.isEditing ? (
					<YesNo
						value={draft}
						onChange={changeValue}
						disabled={controller.canCancel === false}
						deselectable
						size="sm"
						testId={`${testId}-yesno`}
					/>
				) : (
					<YesNoDisplay value={draft} />
				)}
			</EditableMetricCard.ValueRow>
			{caption && <EditableMetricCard.Caption>{caption}</EditableMetricCard.Caption>}
		</EditableMetricCard>
	);
};
